// extracted by mini-css-extract-plugin
export default {"main":"main-module--main--3hXT6"};